"use client";
import ArrowSwiperWithInfoSection, {
  ArrowSwiperWithInfoProps,
} from "@cc/arrow-swiper-with-info-section";
import ArrowSlideInfo from "@cc/cards/arrow-slide-info";
import { ArrowSlideDefaultImageProps } from "@cc/cards/arrow-slide-default-image";

export type VolunteeringProps = {
  title: string;
  data: (ArrowSwiperWithInfoProps<
    typeof ArrowSlideInfo
  >["data"][number]["data"][number] &
    ArrowSlideDefaultImageProps)[];
  navId?: string;
};

const VolunteeringOpportunities = (props: VolunteeringProps) => {
  const { title, data, navId } = props;
  return (
    <ArrowSwiperWithInfoSection
      data={data}
      SwiperKey={VolunteeringOpportunities.name}
      SectionWrapperProps={{
        navId: navId || "volunteering-opportunities",
        color: "primary.main",
        SectionHeaderProps: {
          title: title,
        },
        SectionProps: {
          id: "volunteering-opportunities",
        },
        ContainerProps: {
          pb: 0,
        },
      }}
      ArrowSlideInfoProps={{
        isNavigation: true,
        SlotProps: {
          ButtonProps: {
            href: "#",
            color: "primary",
          },
        },
      }}
    />
  );
};

export default VolunteeringOpportunities;
